import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router'
import { Injectable, Inject } from '@angular/core'
import { APP_BASE_HREF, Location } from '@angular/common'

@Injectable()
export class RouteWildcardResolver implements Resolve<string> {
    constructor(
        @Inject(APP_BASE_HREF) private appBaseHref: string,
        private location: Location,
        private router: Router
    ) {}

    resolve(route: ActivatedRouteSnapshot): string {
        let basePath = this.appBaseHref
        let path = route.url.map(({ path }) => path).join('/')
        path = path.startsWith('/') ? path : `/${path}`

        if (basePath.startsWith('http') || basePath.startsWith('//')) {
            const originSliceIndex = [...basePath].findIndex(
                (char, idx) => this.location.normalize(window.location.origin)[idx] !== char
            )
            basePath = originSliceIndex > -1 ? basePath.slice(originSliceIndex) : '/'
        }

        const sliceIndex = [...path].findIndex((char, idx) => basePath[idx] !== char)
        path = sliceIndex > -1 ? path.slice(sliceIndex) : '/'
        path = path.startsWith('/') ? path : `/${path}`

        this.router.navigate([path])

        return 'Navigation complete'
    }
}
